// @flow

import React from 'react';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';

import {
  injectSheet,
  SmallText,
  type InjectSheetProvidedProps,
  type ThemeType
} from '@catalytic/catalytic-ui';
import { AUTH_REQUEST_INVITE } from '../const/path';

export const Style = (theme: ThemeType) => ({
  root: {
    margin: '0 auto',
    padding: '0 1rem',
    flexFlow: 'column',
    textAlign: 'center',
    [theme.breakpoints.gt.tablet.landscape]: {
      padding: '1.5rem .5rem'
    }
  },
  inviteLink: {
    ...theme.typography.header5
  },
  requestLabel: {
    color: theme.colors.pebbleGrey
  },
  troubleLink: {
    ...theme.typography.header5,
    margin: '0.5rem 0'
  }
});

type Props = InjectSheetProvidedProps;

export const LoginHelp = ({ classes }: Props) => {
  return (
    <div className={classes.root}>
      <a
        className={classes.troubleLink}
        data-testid="login-help"
        href="https://help.catalytic.com/docs/trouble-signing-in/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <FormattedMessage
          id="login.signInTroubleLink"
          defaultMessage="Trouble signing in?"
        />
      </a>
      <SmallText className={classes.requestLabel}>
        <FormattedMessage
          id="login.noAccountMessage"
          defaultMessage="Don't have an account?"
        />
      </SmallText>
      <Link
        to={AUTH_REQUEST_INVITE}
        className={classes.inviteLink}
        data-testid="request-invite"
      >
        <FormattedMessage
          id="login.requestInvite"
          defaultMessage="Request an invite"
        />
      </Link>
    </div>
  );
};
LoginHelp.displayName = 'LoginHelp';

export default injectSheet(Style)(LoginHelp);
